module.exports = __webpack_public_path__ + "img/task-icon.42bb0953.png";